













import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import OpenBrokerageSearch from "@/shared/components/investments/drivewealth/OpenBrokerageSearch.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    AccountTypeSubheader,
    OpenBrokerageSearch
  }
})
export default class DrivewealthChoiceOptionFundsList extends Vue {
  @Prop() accountId: number;

  drivewealthStore = useDrivewealthStore();
}
